"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRequesterRioux = exports.isCAPUnitDutyPosition = exports.isCAPMember = exports.getFullNameLFMI = exports.isValidMemberReference = exports.getUserID = exports.isRioux = exports.hasOneDutyPosition = exports.hasDutyPositions = exports.hasDutyPosition = exports.asReference = exports.hasPermission = exports.hasSpecificPermission = exports.getExpireTime = exports.getFullMemberName = exports.getMemberName = exports.areMembersTheSame = exports.getMemberEmails = exports.getMemberEmail = exports.getMemberPhone = exports.parseStringMemberReference = exports.toReference = exports.stringifyMemberReference = void 0;
const ramda_1 = require("ramda");
const Either_1 = require("./Either");
const Maybe_1 = require("./Maybe");
const ACCOUNT_TOKEN_AGE = 24 * 60 * 60 * 1000;
const stringifyMemberReference = (ref) => `${ref.type}-${ref.id}`;
exports.stringifyMemberReference = stringifyMemberReference;
const toCAPNHQReference = (id) => ({
    type: 'CAPNHQMember',
    id,
});
const toReference = (member) => ({
    type: member.type,
    id: member.id,
});
exports.toReference = toReference;
exports.parseStringMemberReference = ramda_1.pipe(Either_1.Either.right, Either_1.Either.map(str => str.split('-')), Either_1.Either.map(([type, ...idparts]) => [
    type,
    idparts.join('-'),
]), Either_1.Either.flatMap(([type, id]) => type === 'CAPNHQMember'
    ? ramda_1.pipe((x) => parseInt(x, 10), Either_1.Either.right, Either_1.Either.filter(ramda_1.complement(isNaN))({
        type: 'OTHER',
        code: 400,
        message: 'Invalid member ID',
    }), Either_1.Either.map(toCAPNHQReference))(id)
    : type === 'CAPProspectiveMember'
        ? Either_1.Either.right({
            type: 'CAPProspectiveMember',
            id,
        })
        : Either_1.Either.left({
            type: 'OTHER',
            code: 400,
            message: 'Invalid member type',
        })));
const getMemberPhone = (contact) => Maybe_1.Maybe.fromValue(contact.CELLPHONE.PRIMARY ||
    contact.WORKPHONE.PRIMARY ||
    contact.HOMEPHONE.PRIMARY ||
    contact.CADETPARENTPHONE.PRIMARY ||
    contact.CELLPHONE.SECONDARY ||
    contact.WORKPHONE.SECONDARY ||
    contact.HOMEPHONE.SECONDARY ||
    contact.CADETPARENTPHONE.SECONDARY ||
    contact.CELLPHONE.EMERGENCY ||
    contact.WORKPHONE.EMERGENCY ||
    contact.HOMEPHONE.EMERGENCY ||
    contact.CADETPARENTPHONE.EMERGENCY);
exports.getMemberPhone = getMemberPhone;
const getMemberEmail = (contact) => Maybe_1.Maybe.fromValue(contact.EMAIL.PRIMARY ||
    contact.CADETPARENTEMAIL.PRIMARY ||
    contact.EMAIL.SECONDARY ||
    contact.CADETPARENTEMAIL.SECONDARY ||
    contact.EMAIL.EMERGENCY ||
    contact.CADETPARENTEMAIL.EMERGENCY);
exports.getMemberEmail = getMemberEmail;
const getMemberEmails = (contact) => [
    contact.EMAIL.PRIMARY,
    contact.CADETPARENTEMAIL.PRIMARY,
    contact.EMAIL.SECONDARY,
    contact.CADETPARENTEMAIL.SECONDARY,
].filter((v) => !!v);
exports.getMemberEmails = getMemberEmails;
const areMembersTheSame = (ref1) => (ref2) => ref1.type === ref2.type && ref1.id === ref2.id;
exports.areMembersTheSame = areMembersTheSame;
const getMemberName = (member) => [member.nameFirst, member.nameLast, member.nameSuffix]
    .filter(s => !!s)
    .map(value => value.trimLeft().trimRight())
    .map(value => value.replace(/\r\n/gm, ''))
    .map(value => value.replace(/(  +)/g, ' '))
    .join(' ');
exports.getMemberName = getMemberName;
const getFullMemberName = (member) => member.memberRank + ' ' + exports.getMemberName(member);
exports.getFullMemberName = getFullMemberName;
const getExpireTime = () => new Date(new Date().getTime() + ACCOUNT_TOKEN_AGE).toLocaleString();
exports.getExpireTime = getExpireTime;
const hasSpecificPermission = (permission) => (threshold) => (user) => user.permissions[permission] === threshold || isRioux(user);
exports.hasSpecificPermission = hasSpecificPermission;
const hasPermission = (permission) => (threshold) => (user) => user.permissions[permission] === threshold || isRioux(user);
exports.hasPermission = hasPermission;
const asReference = (member) => member.type === 'CAPNHQMember'
    ? {
        type: 'CAPNHQMember',
        id: member.id,
    }
    : {
        type: 'CAPProspectiveMember',
        id: member.id,
    };
exports.asReference = asReference;
const hasDutyPosition = (dutyPosition) => (member) => isRioux(member) || member.dutyPositions.map(duty => duty.duty).includes(dutyPosition);
exports.hasDutyPosition = hasDutyPosition;
const hasDutyPositions = (dutyPositions) => (member) => dutyPositions.some(duty => exports.hasDutyPosition(duty)(member));
exports.hasDutyPositions = hasDutyPositions;
exports.hasOneDutyPosition = exports.hasDutyPositions;
function isRioux(cm) {
    if (typeof cm === 'number' || typeof cm === 'string') {
        return cm === 542488 || cm === 546319;
    }
    if ('id' in cm) {
        return isRioux(cm.id);
    }
    return false;
}
exports.isRioux = isRioux;
function getUserID(name) {
    let usrID = '';
    usrID = name[2] + ((name[0] || '')[0] || '') + ((name[1] || '')[0] || '');
    return usrID.toLocaleLowerCase();
}
exports.getUserID = getUserID;
function isValidMemberReference(value) {
    if (typeof value !== 'object' || value === null || value === undefined) {
        return false;
    }
    if (!('type' in value) ||
        typeof value.type !== 'string' ||
        !('id' in value)) {
        return false;
    }
    const val2 = value;
    if (val2.type === 'CAPNHQMember' && typeof val2.id === 'number') {
        return true;
    }
    if (val2.type === 'CAPProspectiveMember' && typeof val2.id === 'string') {
        return true;
    }
    return false;
}
exports.isValidMemberReference = isValidMemberReference;
const getFullNameLFMI = (member) => {
    let buildName = member.nameLast + ', ' + member.nameFirst;
    if (member.nameMiddle) {
        buildName += ' ' + member.nameMiddle[0];
    }
    if (member.nameSuffix) {
        buildName += ', ' + member.nameSuffix;
    }
    return buildName;
};
exports.getFullNameLFMI = getFullNameLFMI;
const isCAPMember = (member) => member.type === 'CAPNHQMember' || member.type === 'CAPProspectiveMember';
exports.isCAPMember = isCAPMember;
const isCAPUnitDutyPosition = (dutyPosition) => dutyPosition.type === 'CAPUnit';
exports.isCAPUnitDutyPosition = isCAPUnitDutyPosition;
const isRequesterRioux = (req) => isRioux(req.member);
exports.isRequesterRioux = isRequesterRioux;
//# sourceMappingURL=Member.js.map